export interface ChangeMapStyleProps {
  style: string
  setStyle: (style: string) => void
}

export function handleChangeMapStyle({ style, setStyle }: ChangeMapStyleProps) {
  setStyle(style)
}
